import { MILES_PER_HOUR_VALUE } from './imperial-values.helpers';

export function kilometersPerHourToMilesPerHour(kilometersPerHour: number): number {
  return kilometersPerHour * MILES_PER_HOUR_VALUE;
}
